import useProgressBar from "../hooks/useProgressBar";
import ToastShell from "./ToastShell";

/**
 * Loading toast with a phased progress bar, tuned for ~15s report downloads.
 *
 * Progress phases:
 *   0–10 s  → fill from 0% to 82%  (represents the bulk of the work)
 *   10s+    → slowly creep to 90%  (fallback if the call takes longer)
 *   on complete → jump to 100%
 */
const FILL_END_S = 10;
const FILL_TARGET_PCT = 82;
const CREEP_CAP_PCT = 90;

const computeProgress = (elapsed) => {
  if (elapsed <= FILL_END_S) {
    return FILL_TARGET_PCT * (elapsed / FILL_END_S);
  }
  const fraction = Math.min((elapsed - FILL_END_S) / 15, 1);
  return FILL_TARGET_PCT + (CREEP_CAP_PCT - FILL_TARGET_PCT) * fraction;
};

const ReportDownloadToast = ({ t }) => {
  const progress = useProgressBar(t.completed, computeProgress);

  return <ToastShell t={t} progress={progress} />;
};

export default ReportDownloadToast;
